// SearchInput.js
import React, { useState, useEffect } from "react";
import { MagnifyingGlassIcon, XMarkIcon } from "@heroicons/react/24/solid";
import classes from "./searchInput.module.css";

export const SearchInput = ({ placeholder, value, onChange, onSearch, onClear }) => {
  const [text, setText] = useState(value || "");

  useEffect(() => {
    setText(value || "");
  }, [value]);

  const handleSearch = (e) => {
    e.preventDefault();
    onSearch?.(text);
  };

  const handleClear = () => {
    setText("");
    onClear?.();
  };

  return (
    <form onSubmit={handleSearch} className={classes.wrapper}>
      <input
        type="text"
        placeholder={placeholder}
        className={classes.input}
        value={text}
        onChange={(e) => {
          setText(e.target.value);
          onChange?.(e.target.value);
        }}
      />
      <button
        type={text ? "button" : "submit"}
        className={classes.iconBtn}
        onClick={text ? handleClear : undefined}
      >
        {text ? <XMarkIcon className={classes.icon} /> : <MagnifyingGlassIcon className={classes.icon} />}
      </button>
    </form>
  );
};
